export default __webpack_public_path__ + "static/media/5.00be4d04.jpg";